/*
 * AsiFaviconManager — applies ASI favicon / apple-touch / OG tags on the
 * appliedsuperintelligence.com host (and restores prior head tags on leave).
 *
 * Mounted once inside the Router (so it can read the active location), same
 * pattern as FusionMsiFaviconManager. Gated on isAsiMarketingHost() so other
 * hosts are untouched.
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { applyAsiBranding } from "../marketing/asiBranding";
import { isAsiMarketingHost } from "../marketing/asiMarketingRouting";

export default function AsiFaviconManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isAsiMarketingHost()) return undefined;
    return applyAsiBranding();
  }, [pathname]);

  return null;
}
